import { Row, Col, Image } from "antd";
import { Typography, FormControlLabel, Switch, TextField, Tooltip, IconButton } from "@mui/material";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import infoMarkIcon from "../../../../../../assets/images/icon_actions/infoMark.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../../Shared/components/Icons/Date";
import moment from 'moment';

export const LineView = (props) => {
    const { classes, clsx, form, error, changeHandler,
        supplierApi, changeSupplier, currencyFormat, status, view, cashDiscountDetails, parameterDetails, taxCodedetails, otherTaxesdetails, lines,
        supplierDetails, customObject, idNamingConversion, capitalizeFirstLetter } = props;
    return (
        <>
            <Row>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                </Col>
            </Row>
            <Row gutter={50}>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Row gutter={50}>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Order Number</Typography>
                            <Typography variant={'h6'} className={clsx(classes.bold, classes.fontsize18)}>{form?.serialNo || '---'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Row>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Supplier ID</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.supplier?.serialNo || '----'}</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className={classes.textAlignRight}>
                                    <span className={clsx(classes.statusButton,
                                        { [classes.submittedButton]: status === 'REQUESTED' || status === 'RECEIVED' },
                                        { [classes.acceptedButton]: status === 'ACCEPTED' },
                                        { [classes.openButton]: status === 'REJECTED' },
                                        { [classes.reSubmittedButton]: status === 'RESUBMITTED' },
                                        { [classes.cancelledButton]: status === 'CANCELLED' },
                                        { [classes.confirmedButton]: status === 'DELIVERED' || status === 'ORDERED' },
                                        classes.margin20t)}>{status || 'CREATED'}</span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Row>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>In-AppTransactions</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.inAppTransition ? 'Yes' : 'No'}</Typography>
                                        </> :
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                }}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => changeHandler(!form?.inAppTransition, 'inAppTransition')}
                                                />}
                                                id={idNamingConversion('In-AppTransactions', 'salesOrder', 'Radio')}
                                                label="In-AppTransactions"
                                                labelPlacement="top"
                                                checked={form?.inAppTransition}
                                                disabled={form?.inAppStatus === 'ACCEPTED' ? false : true}
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                    }
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                    {
                                        view ? <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>On Hold</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.isHold ? 'Yes' : 'No'}</Typography>
                                        </> :
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                                }}
                                                id={idNamingConversion('Hold', 'salesOrder', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => changeHandler(!form?.isHold, 'isHold')}
                                                />}
                                                label="Hold"
                                                labelPlacement="top"
                                                checked={form?.isHold}
                                                className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                            />
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Price Includes Tax</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.priceIncludesTax ? 'Yes' : 'No'}</Typography>
                                </> : <FormControlLabel
                                    classes={{
                                        label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                    }}
                                    id={idNamingConversion('Price Includes Tax', 'supplyOrder', 'Radio')}
                                    control={<Switch size='small'
                                        className={clsx(classes.customSwitch)}
                                        onChange={(e) => changeHandler(!form?.priceIncludesTax, 'priceIncludesTax')}
                                    />}
                                    label="Price Includes Tax"
                                    labelPlacement="top"
                                    checked={form?.priceIncludesTax}
                                    disabled={true}
                                    className={clsx(classes.marginLeft0, classes.margin20t, classes.flexStart)}
                                />
                            }
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Comments</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.comments || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Comments"]}
                                        fullWidth
                                        name={"comments"}
                                        id={idNamingConversion('Comments', 'supplyOrder', 'TextField')}
                                        variant={'standard'}

                                        value={form?.comments || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        inputProps={{
                                            "aria-autocomplete": "none"
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Supplier Name </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.supplier?.name || '---'}</Typography>
                                </> : <AutoCompleteComponent
                                    name={["Supplier Name ", <span key={"Supplier Name"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Supplier Name' },
                                    { 'key': 'mobile', 'name': 'Phone Number' },
                                    { 'key': 'serialNo', 'name': 'Supplier ID' }]}
                                    details={supplierDetails}
                                    id={idNamingConversion('supplierName', 'supplyOrder', 'DropDown')}
                                    parentValue={customObject(supplierDetails, form?.supplierId)}
                                    onChange={(data) => changeSupplier(data)}
                                    searchType={(s) => supplierApi(s)}
                                    parentError={error?.supplierId || false}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Phone Number </Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.phone || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Phone Number ", <span key={"Phone Number"} className={classes.colorRedRequired}> *</span>]}
                                        fullWidth
                                        //type="number"
                                        name={"phone"}
                                        id={idNamingConversion('Phone Number', 'supplyOrder', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        error={error?.phone && true}
                                        helperText={error?.phone}
                                        variant={'standard'}
                                        value={form?.phone || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.textFieldLableColorCustom, { [classes.margin20t]: !view }, { [classes.margin30t]: view }, 'MuiInputLabel-shrink', classes.fonSize13)}>Created By</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.createdBy || '----'}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                {
                                    view ?
                                        <>
                                            <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Requested Receipt Date</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                                {form.deliveryDate ? moment(form.deliveryDate).format('DD MMM YYYY') : '---'}
                                            </Typography>
                                        </> :
                                        <LocalizationProvider
                                            dateAdapter={AdapterDateFns}>
                                            <DesktopDatePicker
                                                tabIndex={-1}
                                                fullWidth
                                                slots={{
                                                    openPickerIcon: DateIcon
                                                }}
                                                views={['year', 'month', 'day']}
                                                value={form?.deliveryDate || null}
                                                label="Requested Receipt Date"
                                                PopperProps={{
                                                    className: classes.dateAdjust,
                                                }}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        error: error?.deliveryDate ? true : false,
                                                        helperText: error?.deliveryDate,
                                                        id: idNamingConversion('Requested Receipt Date', 'supplyOrder', 'TextField'),
                                                        autoComplete: 'one-time-code'
                                                    },
                                                }}
                                                minDate={form?.transactionDate}
                                                format="dd/MM/yyyy"
                                                onChange={(newValue, newError) => {
                                                    if (newError?.validationError || newValue === null) {
                                                        changeHandler(new Date(), 'deliveryDate');
                                                    } else {
                                                        changeHandler(newValue, 'deliveryDate');
                                                    }
                                                }}

                                            />
                                        </LocalizationProvider>
                                }
                            </div>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin30t, classes.fonSize13)}>Reference</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.reference || '---'}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["Reference"]}
                                        fullWidth
                                        name={"reference"}
                                        id={idNamingConversion('Reference', 'supplyOrder', 'TextField')}
                                        className={clsx(classes.margin20t)}
                                        variant={'standard'}
                                        value={form?.reference || ''}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor
                                            }
                                        }}
                                        disabled={form?.inAppTransition || false}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Totals</Typography>
                        </Col>
                        {parameterDetails?.purchaseValue && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Purchase Total</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(lines?.length > 0 ? lines?.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.purchaseValue || 0), 0) : 0)}</Typography>
                        </Col>
                        }
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Discount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.totalDiscount || 0)}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Net Amount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.netAmount || 0)}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                <span>GST Amount </span>
                                <Tooltip tabIndex={-1}
                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidthSales) }}
                                    title={'Rounded to 2 decimal places'} arrow placement="top"
                                    className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                    <IconButton>
                                        <Image src={infoMarkIcon} preview={false} />
                                    </IconButton>
                                </Tooltip> </Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.gstAmount || 0)}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Round Off</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.roundOffMethod || 'BLANK')} - ₹ {currencyFormat(form?.roundOffAmount || 0)}</Typography>
                                </> : <Row>
                                    <Col xxl={6} xl={6} lg={10} md={10} sm={6} xs={6}>
                                        <AutoCompleteComponent
                                            name={["Round Off"]}
                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                            details={[{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }]}
                                            id={idNamingConversion('Round off', 'supplyOrder', 'DropDown')}
                                            parentValue={customObject([{ id: '', name: 'Blank' }, { id: 'UP', name: 'Up' }, { id: 'DOWN', name: 'Down' }], form?.roundOffMethod)}
                                            onChange={(data) => changeHandler(data?.id, 'roundOffMethod')}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={18} xl={18} lg={14} md={14} sm={18} xs={18}>
                                        <TextField autoComplete='one-time-code'
                                            label={[""]}
                                            fullWidth
                                            type="number"
                                            id={idNamingConversion('Round Off Amount', 'supplyOrder', 'TextField')}
                                            className={clsx(classes.margin20t)}
                                            error={error?.roundOffAmount && true}
                                            helperText={error?.roundOffAmount}
                                            variant={'standard'}
                                            name="roundOffAmount"
                                            value={form.roundOffAmount}
                                            InputProps={{
                                                classes: {
                                                    input: clsx(classes.textFieldColor, classes.padding10L)
                                                }
                                            }}
                                            inputProps={{
                                                step: "any"
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom
                                            }}
                                            disabled={form?.roundOffMethod ? false : true}
                                            onChange={(e) => changeHandler(e)}
                                        />
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Order Amount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.invoiceAmount || 0)}</Typography>
                        </Col>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Cash Discount</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.cashDiscount?.code || '---')} - ₹ {currencyFormat(form?.cashDiscountAmount || 0)}</Typography>
                                </> : <Row gutter={20}>
                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                        <AutoCompleteComponent
                                            name={["Cash Discount"]}
                                            heads={[{ 'key': 'code', 'name': 'Code' }]}
                                            details={cashDiscountDetails || []}
                                            id={idNamingConversion('Cash Discount', 'salesQuote', 'DropDown')}
                                            parentValue={customObject(cashDiscountDetails || [], form?.cashDiscountId)}
                                            onChange={(data) => changeHandler(data, 'cashDiscountId', true)}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Amount</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.cashDiscountAmount || 0)}</Typography>
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Excise Amount</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.excisesAmount || 0)}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Assessable Value</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.assessableValue || 0)}</Typography>
                        </Col>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Tax Code</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.taxCode?.code || '---')} - ₹ {currencyFormat(form?.tax || 0)}</Typography>
                                </> : <Row gutter={20}>
                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                        <AutoCompleteComponent
                                            name={["Tax Code"]}
                                            heads={[{ 'key': 'code', 'name': 'Code' }]}
                                            details={taxCodedetails || []}
                                            id={idNamingConversion('Tax Code', 'salesQuote', 'DropDown')}
                                            parentValue={customObject(taxCodedetails || [], form?.taxCodeId)}
                                            onChange={(data) => changeHandler(data, 'taxCodeId', true)}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.tax || 0)}</Typography>
                                    </Col>
                                </Row>
                            }
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={24}>
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>TCS</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                        {capitalizeFirstLetter(form?.tcsName?.name || '---')} - ₹ {currencyFormat(form?.tcs || 0)}</Typography>
                                </> : <Row gutter={20}>
                                    <Col xxl={10} xl={10} lg={10} md={10} sm={10} xs={10}>
                                        <AutoCompleteComponent
                                            name={["TCS"]}
                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                            details={(otherTaxesdetails || []).filter(el => el.taxType === 'TCS')}
                                            id={idNamingConversion('TCS', 'salesQuote', 'DropDown')}
                                            parentValue={customObject((otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), form?.tcsNameId)}
                                            onChange={(data) => changeHandler(data, 'tcsNameId', true)}
                                            position={"bottom"}
                                            disabled={!form?.supplier?.tcsBoolean}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.margin20TopSales, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Tax</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>₹ {currencyFormat(form?.tcs || 0)}</Typography>
                                    </Col>
                                </Row>
                            }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}